<template>

    <div class="row">
       <StatsCard v-for="(stat, i) in items?.stats ?? []" :key="i" :stat="stat" />

     
       <div class="col-lg-12">  <div class="card my-3 " style="height: 500px;" >
            <div class="card-header">
                <span>Evoultion des plaintes au cour de cette année </span>
            </div>
            <div class="card-body">
                
                <Line id="my-chart-ids" :options="chartOptions" :data="{
                    labels: Object.keys(items?.histogram ?? []).map((e) => {
                        return this.monthsList[e - 1];
                    }), datasets: [{ data: Object.values(items?.histogram ?? []), label: 'Plaintes',
                    backgroundColor: '#0a3866',}]
                }" />
            </div>
        </div></div>
    </div>
</template>
<script>

import StatsCard from "@/widgets/StatsCard.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

import {  Line } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,PointElement,LineElement)
export default {
    name: "TableauBord",
    components: {
        StatsCard,
        // Bar,
        Line
    },
    data() {
        return {
            monthsList: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
            
            chartOptions: {
                responsive: true,
               
  maintainAspectRatio: false
            }
        }
    },
    computed: {
        ...mapFields("dashboard/list", {
            isLoading: "isLoading",
            items: "items",
            isSuccess: "isSuccess",
            showMessage: "showMessage",
            message: "message",

        })
    },
    methods: {
        ...mapActions({
            getDashboard: "dashboard/list/getAll"
        })
    },
    mounted() {
        this.getDashboard()
    }


}
</script>
